import ProduccionLayout from '@/components/ProduccionLayout';
import FincaTab from './FincaTab';

export default function ProduccionNew({ user, onLogout }) {
  return (
    <ProduccionLayout user={user} onLogout={onLogout}>
      <FincaTab user={user} onLogout={onLogout} />
    </ProduccionLayout>
  );
}
